import { Fragment } from 'react';
import { accordionComponentJsxPrinters } from '@pm2/accordion-component';
import { flashcardComponentJsxPrinters } from '@pm2/flashcard-component';
import { geogebraComponentJsxPrinters } from '@pm2/geogebra-component';
import { iArkComponentJsxPrinters } from '@pm2/i-ark-component';
import { iGuideComponentJsxPrinters } from '@pm2/i-guide-component';
import { iframeComponentJsxPrinters } from '@pm2/iframe-component';
import { imageComponentJsxPrinters } from '@pm2/image-component';
import { imageHotspotsComponentJsxPrinters } from '@pm2/image-hotspots-component';
import { mediaComponentJsxPrinters } from '@pm2/media-component';
import { opgavekompleksetComponentJsxPrinters } from '@pm2/opgavekomplekset-component';
import { sliderComponentJsxPrinters } from '@pm2/slider-component';
import { textComponentJsxPrinters } from '@pm2/text-component';
import { componentFrameworkErrorJsxPrinters } from '@pm2/ui-components';
import { generateJsxKey } from '@utils/ast';
import { GridComponent } from './grid.js';
import { jsx } from 'react/jsx-runtime';

const printGridComponent = (node, context) => {
  const columns = node.children;
  if (!columns.length) {
    return null;
  }
  return /*#__PURE__*/jsx(GridComponent, {
    children: columns.map(columnNode => ({
      size: columnNode.meta.size,
      children: context.printChildren(columnNode, {
        "grid-component.column": printGridComponentColumn
      })
    }))
  }, generateJsxKey(context));
};
const printGridComponentColumn = (node, context) => {
  return /*#__PURE__*/jsx(Fragment, {
    children: context.printChildren(node.children, {
      ...accordionComponentJsxPrinters,
      ...componentFrameworkErrorJsxPrinters,
      ...flashcardComponentJsxPrinters,
      ...geogebraComponentJsxPrinters,
      ...gridComponentJsxPrinters,
      ...iArkComponentJsxPrinters,
      ...iframeComponentJsxPrinters,
      ...iGuideComponentJsxPrinters,
      ...imageComponentJsxPrinters,
      ...imageHotspotsComponentJsxPrinters,
      ...mediaComponentJsxPrinters,
      ...opgavekompleksetComponentJsxPrinters,
      ...sliderComponentJsxPrinters,
      ...textComponentJsxPrinters
    })
  }, generateJsxKey(context));
};
const gridComponentJsxPrinters = {
  "grid-component": printGridComponent
};

export { gridComponentJsxPrinters, printGridComponent, printGridComponentColumn };
//# sourceMappingURL=printer.to-jsx.js.map
